package pt.at.oss.kotlin.manual.schema.common.tradingnames

import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.TRADING_NAME_MAX_LEN
import pt.at.oss.kotlin.manual.enumeration.FieldSizeConstants.TRADING_NAME_MIN_LEN
import pt.at.oss.kotlin.manual.storage.common.tradingnames.TradingNamesEntry
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * TradingNamesEntrySchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class TradingNamesEntrySchema : RecordSchema<TradingNamesEntry>(name = "tradingNames") {

    val nameSchema: StringSchema = StringSchema(name = "name", minLength = TRADING_NAME_MIN_LEN, maxLength = TRADING_NAME_MAX_LEN)
    override fun isValid(value: TradingNamesEntry?): Boolean {
        return value == null || (
            nameSchema.isValid(value.name)
            )
    }

    override fun validate(value: TradingNamesEntry?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(nameSchema.validate(value.name, appendToPath(path, "name")))
        return validator
    }
}
